import { render, staticRenderFns } from "./LearnMore.vue?vue&type=template&id=3dffb81c&scoped=true"
import script from "./LearnMore.vue?vue&type=script&lang=js"
export * from "./LearnMore.vue?vue&type=script&lang=js"
import style0 from "./LearnMore.vue?vue&type=style&index=0&id=3dffb81c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dffb81c",
  null
  
)

export default component.exports